<template>
  <div class="animated fadeIn">
    <b-row class="mb-3">
      <b-col cols="2" class="pt-2">Sample ID</b-col>
      <b-col>
        <b-form-input type="text" v-model="identifier" placeholder="Sample Name" :state="!$v.identifier.$invalid" invalid-feedback="Required" />
      </b-col>
      <b-col v-if="samples.length > 1" cols="1" class="pl-0">
        <b-button @click="removeSample" variant="danger" block>
          <i class="fa fa-trash" />
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Sample Animal Fed" :label-cols="2" :state="!$v.animal_fed.$invalid" invalid-feedback="Required" :horizontal="true">
          <add-on-select :selectedItem="animal_fed" :customPlaceholder="'Select Sample Animal Fed'" :options="animalFedOptions" @change="handleSelect" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Sample Type" :label-cols="2" :state="!$v.type.$invalid" invalid-feedback="Required" :horizontal="true">
          <add-on-select :selectedItem="type" :customPlaceholder="'Select Sample Type'" :options="type_options" @change="handleSelect" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group label="Add On(s)" label-cols="2">
      <b-button v-b-toggle="`addOns-${sampleId}${submissionId}`" :variant="add_ons.length ? 'primary' : 'dark'" block>Options</b-button>
      <b-collapse :id="`addOns-${sampleId}${submissionId}`" class="mt-2">
        <custom-form-checkbox-group v-model="add_ons" v-if="addOns.length" :lg="2" :md="2" :options="addOns.map((i) => ({ text: i.name, value: i.id, icon: 'cube' }))
          " />
      </b-collapse>
    </b-form-group>
    <hr />
  </div>
</template>
<script>
import CustomFormCheckboxGroup from "@/components/shared/form/CustomFormCheckboxGroup";
import AddOnSelect from "../../misc/AddOnSelect";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate/src";
import { getCollection } from "@/shared/fetch-utils";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectFeedsSampleFormGroup",
  components: { AddOnSelect, CustomFormCheckboxGroup },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    sampleId: {
      type: String,
      default: "",
    },
    addOns: {
      type: Array,
      default: () => [],
    },
    animalFedOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    managedListId: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    sample() {
      return this.samples.find(
        (sample) => sample.test_package_sample_id === this.sampleId
      );
    },
    sample_feeds() {
      return this.sample.sample_feeds;
    },
    identifier: {
      get() {
        return this.sample.identifier;
      },
      set(value) {
        this.handleSampleChange({
          field: "identifier",
          value,
        });
      },
    },
    type() {
      return this.sample_feeds.type;
    },
    animal_fed() {
      return this.sample_feeds.animal_fed;
    },
    add_ons: {
      get() {
        return this.sample.add_ons;
      },
      set(value) {
        this.handleSampleChange({
          field: "add_ons",
          value,
        });
      },
    },
  },
  data() {
    return {
      type_options: {
        options: [],
        field: "type"
      }
    };
  },
  validations: {
    identifier: { required },
    type: { required },
    animal_fed: { required },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION_SAMPLE"]),
    handleSampleChange({ field, value }) {
      this.UPDATE_SUBMISSION_SAMPLE({
        submission_id: this.submissionId,
        sample_id: this.sampleId,
        sample_update: {
          ...this.sample,
          [field]: value,
        },
      });
    },
    handleSelect({ selected, field }) {

      this.handleSampleChange({
        value: {
          ...this.sample_feeds,
          [field]: selected,
        },
        field: "sample_feeds",
      });
    },
    removeSample() {
      this.$emit("updateSampleList", "remove", this.sampleId);
    },

    /**
     * Fetch list of attributes matching the currently set animal type
     */
    async fetchRelatedAttributeList() {
      if (!this.animal_fed) {
        this.type_options = {
          options: []
        };
        return
      }

      // get collection of attributes
      let collection = await getCollection({
        collection_type: "attribute_list",
        sort: [
          {
            logic: "sortAddAsc",
            field: "value",
          },
        ],
        filters: [
          {
            logic: "filterEquals",
            field: "managed_list_id",
            value: this.managedListId
          },
          {
            logic: "filterEquals",
            field: "parent.parent_id",
            value: this.animal_fed
          }
        ],
        limit: "all",
        message: this.$bvToast
      });

      // get options from collection
      let options = collection.models.map(({ id, value }) => {
        return {
          id: id,
          name: value
        };
      });

      // return formatted object
      return {
        options: options,
        field: "type",
      };
    }
  },
  watch: {
    animal_fed: {
      async handler() {
        if (!this.animal_fed) {
          this.type_options = {
            options: [],
            field: "type"
          };
          return;
        }

        // 
        this.type_options = await this.fetchRelatedAttributeList();
      }
    }
  },
  async created() {
    this.type_options = {
      options: [],
      field: "type"
    };

    // fetch related attribute list
    this.type_options = await this.fetchRelatedAttributeList();
  }
};
</script>
